module.exports = __webpack_public_path__ + "static/img/082_TO8_1730.33d9eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/082_TO8_1730.jpg
// module id = 30j9
// module chunks = 0